module.exports = __webpack_public_path__ + "static/img/TESLA.8ea50de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/TESLA.png
// module id = ZEld
// module chunks = 1